import React from 'react';

import { Messages } from '~src/codegen/Localize';
import { IActivityLogConnection } from '~src/settings/IntegrationsSettings/serverApi/types/IActivityLog';

import { activityLogStatusTable, activityLogStatusTableHeader } from '../styles/ActivityLogSettingsStyles';
import { ACTIVITY_LOG } from './ActivityLogSettings';

export interface ActivityLogConnectionStatusProps {
    connection: IActivityLogConnection;
}

export function ActivityLogConnectionStatus(props: ActivityLogConnectionStatusProps) {
    return <div>
        <table className={activityLogStatusTable} data-tb-test-id={`${ACTIVITY_LOG}-connection-status-table`}>
                <ActivityLogConnectionStatusTableHeaders/>
                <ActivityLogConnectionStatusTableBody {...props}/>
        </table>
    </div>;
}

function ActivityLogConnectionStatusTableHeaders() {
    return <>
    <thead>
        <tr>
            <th className={activityLogStatusTableHeader}>
                <span className='tb-data-grid-header-text' data-tb-test-id={`${ACTIVITY_LOG}-aws-acct-number-header`}>
                    {Messages.awsAccountNumber()}
                </span>
            </th>
            <th className={activityLogStatusTableHeader}>
                <span className='tb-data-grid-header-text' data-tb-test-id={`${ACTIVITY_LOG}-s3-bucket-header`}>
                    {Messages.s3BucketName()}
                </span>
            </th>
            <th className={activityLogStatusTableHeader}>
                <span className='tb-data-grid-header-text' data-tb-test-id={`${ACTIVITY_LOG}-kms-key-arn-header`}>
                    {Messages.kmsKeyArn()}
                </span>
            </th>
            <th className={activityLogStatusTableHeader}>
                <span className='tb-data-grid-header-text' data-tb-test-id={'connection-status-header'}>
                    {Messages.connectionStatusHeader()}
                </span>
            </th>
        </tr>
    </thead></>;
}

function ActivityLogConnectionStatusTableBody(props: ActivityLogConnectionStatusProps) {
    const friendlySiteCEPPConfigurationState = new Map<String, String>([
        ['NOT_ENABLED', Messages.activityLogNotEnabled()],
        ['IN_PROGRESS', Messages.activityLogInProgress()],
        ['PENDING_VERIFICATION', Messages.activityLogPendingVerification()],
        ['ACTIVE', Messages.active()],
        ['FAILED', Messages.activityLogFailed()],
        ['DEACTIVATED', Messages.activityLogDeactivated()]
    ]);

    return (
        <tbody>
            <tr>
            <td><span className='tb-data-grid-cell-text tb-lr-padded-wide' data-tb-test-id={`${ACTIVITY_LOG}-aws-acct-number-body`}>{props.connection.configuration.awsAccountNumber}</span></td>
            <td><span className='tb-data-grid-cell-text tb-lr-padded-wide' data-tb-test-id={`${ACTIVITY_LOG}-s3-bucket-body`}>{props.connection.configuration.s3BucketName}</span></td>
            <td><span className='tb-data-grid-cell-text tb-lr-padded-wide' data-tb-test-id={`${ACTIVITY_LOG}-kms-key-arn-body`}>{props.connection.configuration.kmsKeyARN}</span></td>
            <td><span className='tb-data-grid-cell-text tb-lr-padded-wide' data-tb-test-id={`${ACTIVITY_LOG}-connection-status-body`}>{friendlySiteCEPPConfigurationState.get(props.connection.connectionStatus)}</span></td>
          </tr>
        </tbody>
    );
}
